import { render, staticRenderFns } from "./editProductItem.vue?vue&type=template&id=b16167ca&scoped=true&"
import script from "./editProductItem.vue?vue&type=script&lang=js&"
export * from "./editProductItem.vue?vue&type=script&lang=js&"
import style0 from "./editProductItem.vue?vue&type=style&index=0&id=b16167ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16167ca",
  null
  
)

export default component.exports